import { useState } from 'react';

/**
 * Renders the sender's company logo image, or `fallback` when there is no logo
 * URL or the image fails to load. The broken-image guard needs local state, so
 * this is a tiny component rather than an inline <img> at each call site.
 *
 * The logo URL itself is resolved by resolveSenderLogo (src/utils/leadSelectionUtils):
 * a classifier-detected logo from the deal's photos, else a sender-domain favicon.
 *
 * @param {string|null} logoUrl    — resolved logo/favicon URL
 * @param {React.ReactNode} fallback — rendered when no logo (e.g. initials, or null)
 * @param {string} [className]      — class for the <img>
 */
export default function SenderLogo({ logoUrl, fallback = null, className }) {
    // Track WHICH url failed, not a bare boolean: in a reused list row (the leads
    // table reconciles this component by position), a new lead's logoUrl must
    // render fresh even if the previous lead's logo errored on this same instance.
    const [failedUrl, setFailedUrl] = useState(null);
    if (!logoUrl || failedUrl === logoUrl) return fallback;
    return (
        <img
            src={logoUrl}
            alt=""
            className={className}
            onError={() => setFailedUrl(logoUrl)}
            referrerPolicy="no-referrer"
        />
    );
}
